import React from 'react';

const Pregnant = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="26"
    viewBox="0 0 20 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.07319 25.1874C9.79165 25.1874 10.3852 24.6087 10.3852 23.9082V15.8677H7.72998V23.9082C7.76122 24.6087 8.35473 25.1874 9.07319 25.1874Z"
      fill="white"
    />
    <path
      d="M8.68973 5.23851C7.22157 5.23851 6.03455 4.08117 6.03455 2.61926C6.03455 1.15735 7.22157 0 8.68973 0C10.1579 0 11.3449 1.15735 11.3449 2.61926C11.3449 4.05071 10.1579 5.23851 8.68973 5.23851Z"
      fill="white"
    />
    <path
      d="M15.2269 13.188C15.2269 11.787 14.3835 10.5078 13.0403 9.92918C12.1031 9.5637 11.3847 8.80229 11.0723 7.85814C10.9786 7.52312 10.8849 7.1881 10.8536 6.9749C10.6975 6.09166 9.91653 5.42162 8.97941 5.39116C7.51125 5.29979 6.91774 5.81755 6.76155 6.88353L5.01225 18.9443C4.98102 19.0661 5.01225 19.1879 5.07473 19.2793C5.1372 19.3707 5.23092 19.4011 5.32463 19.4011H13.6338C13.7275 19.4011 13.8212 19.3402 13.8837 19.2793C13.9462 19.1879 13.9774 19.0661 13.9462 18.9443C13.9149 18.792 13.6963 17.9392 13.5401 17.2692C13.4151 16.7514 13.5713 16.1728 13.9774 15.8073C14.8208 15.1372 15.2269 14.1931 15.2269 13.188ZM13.7587 13.1271C13.6963 13.523 13.3214 13.8276 12.9153 13.8276H12.7904C10.5725 13.4621 7.91733 12.0916 7.82362 7.58403C7.82362 7.12718 8.19847 6.73125 8.66703 6.73125C9.13559 6.73125 9.54168 7.09673 9.54168 7.55357C9.60415 10.3251 10.7287 11.787 13.0715 12.183C13.5088 12.2439 13.8212 12.6703 13.7587 13.1271Z"
      fill="white"
    />
  </svg>
);

export default Pregnant;
